import { get, readable, writable } from "svelte/store";
export default class ChallengePoint {
    get id() {
        return this.challengePointState.id;
    }
    get coords() {
        return this.challengePointState.coords;
    }
    get questions() {
        return this.challengePointState.questions;
    }
    constructor(challengePointState) {
        this.challengePointState = challengePointState;
        this._isCompleted = writable(false);
        this.isCompleted = readable(false, set => this._isCompleted.subscribe(set));
        this._isCompleted.set(challengePointState.isCompleted);
    }
    setCompleted() {
        if (get(this._isCompleted)) {
            return;
        }
        this._isCompleted.set(true);
    }
    getState() {
        return {
            id: this.id,
            coords: this.coords,
            questions: this.questions,
            isCompleted: get(this._isCompleted)
        };
    }
}
